<template>
  <div id="app">
    <Loading :class="{loaded}" v-show="!loaded" />
    <Header />
    <div id="scroller-wrapper" data-scrollbar>
      <router-view/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Footer from './components/Footer.vue'
import Loading from './components/loading.vue'
export default {
  components: {
    Header,
    Footer,
    Loading
  },
  data(){
    return{
      loaded:false,
      count: 0,
      percent: ''
    }
  },
  methods: {
    preload: function() {
      let imgs = [
        "/images/loading-logo-blue.png",
        "/images/loading-logo-gray.png",
        "/images/aboutbanner.jpg",
        "/images/background1.png",
        "/images/background2.jpg",
        "/images/background3.png",
        "/images/background4.jpg",
        "/images/banner3.jpg",
        "/images/border.png",
        "/images/border_h.png",
        "/images/Bulb.png",
        "/images/companyculture.jpg",
        "/images/contactbanner.jpg",
        "/images/historybg.png",
        "/images/icon0.png",
        "/images/icon0_h.png",
        "/images/icon1.png",
        "/images/icon2.png",
        "/images/icon3.png",
        "/images/icon4.png",
        "/images/icon5.png",
        "/images/icon6.png",
        "/images/icon6_h.png",
        "/images/icon7.png",
        "/images/icon7_h.png",
        "/images/jjclose.gif",
        "/images/jobbanner.jpg",
        "/images/keyanbanner.jpg",
        "/images/logo.jpg",
        "/images/map.png",
        "/images/newsbanner.jpg",
        "/images/organization.png",
        "/images/p1.jpg",
        "/images/p2.png",
        "/images/p3.jpg",
        "/images/pen.jpg",
        "/images/productbanner.jpg"
      ]

      for (let img of imgs) {
        let image = new Image()
        image.src = img
        image.onload = () => {
          this.count++
          //console.log(image.src)
        }
      }
    }
  },
  mounted(){
    //Scrollbar.initAll();
    //this.preload()
    setTimeout(()=>{
      this.loaded=true
    },3000)
  },
  watch: {
    /* count: function(val) {
      if (val === 10) {
        // 图片加载完成后跳转页面
        this.loaded=true
      }
    } */
  }
}
</script>

<style>
*{box-sizing: border-box;}
body{
  margin:0;
  padding:0;
  font-family: Arial, "Microsoft YaHei", sans-serif;
}
p{margin: 0;}
a{
  text-decoration: none;
}
.clearfix::before,.clearfix::after{
  content: "";
  display: table;
  
}
.clearfix::after{
  clear: both;
}
.flex{
  display:flex;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-column{
  flex-direction: column;
}
.flex-space-between{
  justify-content: space-between;
}
.flex-justify-center{
  justify-content: center;
}
.flex-align-center{
  align-items: center;
}
#scroller-wrapper{
  position: relative;
  height: 100vh;
}
/* .scrollbar-track-y{
  z-index: 2000 !important;
} */
</style>
